import React, { useState } from 'react';
import { Dialog, DialogHeader, DialogBody, DialogFooter } from '../../ui/Dialog';
import { Button } from '../../ui/Button';
import { Input } from '../../ui/Input';
import { Select } from '../../ui/Input';
import { formatPhoneInput } from '../../../utils/phone';

const ROLE_OPTIONS = [
  { value: 'field_tech', label: 'Field Tech' },
  { value: 'foreman', label: 'Foreman' },
  { value: 'laborer', label: 'Laborer' },
];

export function AddCrewMemberModal({ open, onClose, onAdd, existingMembers = [] }) {
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    role: 'field_tech',
  });
  const [errors, setErrors] = useState({});

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: null }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!form.firstName.trim()) newErrors.firstName = 'First name is required';
    if (!form.lastName.trim()) newErrors.lastName = 'Last name is required';
    if (form.email && existingMembers.some(m => m.email === form.email)) {
      newErrors.email = 'This email is already in a crew';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAdd = () => {
    if (validate()) {
      onAdd(form);
      setForm({ firstName: '', lastName: '', phone: '', email: '', role: 'field_tech' });
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} size="sm">
      <DialogHeader onClose={onClose}>Add Crew Member</DialogHeader>
      <DialogBody>
        <p className="text-sm text-gray-500 mb-4">
          Add a team member directly to this crew. They don't need a BIDIT account to be assigned to work orders.
        </p>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <Input
              label="First Name"
              value={form.firstName}
              onChange={(e) => handleChange('firstName', e.target.value)}
              error={errors.firstName}
              required
            />
            <Input
              label="Last Name"
              value={form.lastName}
              onChange={(e) => handleChange('lastName', e.target.value)}
              error={errors.lastName}
              required
            />
          </div>
          <Input
            label="Phone"
            type="tel"
            value={form.phone}
            onChange={(e) => handleChange('phone', formatPhoneInput(e.target.value))}
            placeholder="(555) 123-4567"
          />
          <Input
            label="Email (optional)"
            type="email"
            value={form.email}
            onChange={(e) => handleChange('email', e.target.value)}
            error={errors.email}
            helperText="If provided, they'll receive work order notifications"
          />
          <Select
            label="Role"
            value={form.role}
            onChange={(e) => handleChange('role', e.target.value)}
          >
            {ROLE_OPTIONS.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </Select>
        </div>
      </DialogBody>
      <DialogFooter>
        <Button variant="secondary" onClick={onClose}>Cancel</Button>
        <Button onClick={handleAdd}>Add Member</Button>
      </DialogFooter>
    </Dialog>
  );
}
